import {AlmeState, defaultState} from "../../../../wireup/AlmeState";
import {AnyAction} from "redux";
import {
    LaunchActionTypes,
    SetAccessKey,
    SetCustomSessionId,
    SetLanguage,
    SetLaunchParameters,
    SetUserMetadata
} from "../actions/Actions";

export default function reduce(state: AlmeState = defaultState, action: AnyAction): AlmeState
{
    let typedAction: LaunchActionTypes;
    switch(action.type) 
    {
        case "LAUNCH_IVA":
            return {
                ...state,
                "Window": {
                    ...state.Window,
                    IsMinimized: false,
                },
            };

        case "SET_LAUNCH_PARAMETERS":
            typedAction = action as SetLaunchParameters;
            return {
                ...state,
                "WelcomeUser": {
                    ...state.WelcomeUser,
                    LaunchPointName: typedAction.payload.launchPointName,
                    LaunchParameter: typedAction.payload.launchParameter,
                    LaunchType: typedAction.payload.launchType,
                },
            };

        case "SET_ACCESS_KEY":
            typedAction = action as SetAccessKey;
            return {
                ...state,
                "Conversation": {
                    ...state.Conversation,
                    AccessKey: typedAction.payload.accessKey,
                },
            };

        case "SET_USER_METADATA":
            typedAction = action as SetUserMetadata;
            return {
                ...state,
                "Conversation": {
                    ...state.Conversation,
                    UserMetadata: typedAction.payload.userMetadata,
                },
            };

        case "SET_LANGUAGE":
            typedAction = action as SetLanguage;
            return {
                ...state,
                "Conversation": {
                    ...state.Conversation,
                    Language: typedAction.payload.language,
                },
            };
        case "SET_CUSTOM_SESSION_ID":
            typedAction = action as SetCustomSessionId;
            return {
                ...state,
                "Conversation": {
                    ...state.Conversation,
                    CustomSessionId: typedAction.customSid,
                },
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/launch-message-processor/src/reducers/index.ts